import { Head } from "./Head"

export function BaseLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Head />
      {children}
    </>
  )
}
